import Icon from '../components/Icon.vue'

Icon.register({
  headset: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M192 208C192 190.3 177.7 176 160 176H144C108.7 176 80 204.7 80 240V288C80 323.4 108.7 352 144 352H160C177.7 352 192 337.7 192 320V208zM368 352C403.4 352 432 323.4 432 288V240C432 204.7 403.4 176 368 176H352C334.3 176 320 190.3 320 208V320C320 337.7 334.3 352 352 352H368zM256 0C113.2 0 4.6 118.8 0 256V272C0 280.8 7.2 288 16 288H32C40.8 288 48 280.8 48 272V256C48 141.3 141.3 48 256 48S464 141.3 464 256H463.9C464 258.4 464 421.7 464 421.7 464 445.1 445.1 464 421.7 464H320C320 437.5 298.5 416 272 416H240C213.5 416 192 437.5 192 464S213.5 512 240 512H421.7C471.6 512 512 471.6 512 421.7V256C507.4 118.8 398.8 0 256 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/headset.js
// module id = 1iiz
// module chunks = 144